/**
 * Keeps Delivery Manager (#haisosm) working in the cart drawer after morph / drawer open.
 */
(function () {
  const HAISOSM_ID = 'haisosm';

  function getSlot() {
    return document.getElementById(HAISOSM_ID);
  }

  function dispatchReady() {
    const slot = getSlot();
    if (!slot) return;

    slot.dispatchEvent(new CustomEvent('haisosm:ready', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('haisosm:ready', { bubbles: true, detail: { slot } }));
  }

  function tryAppReinit() {
    const candidates = [
      window.haisosmInit,
      window.haisosm_init,
      window.HaisosmInit,
      window.haisouManager?.init,
      window.HaisouManager?.init,
    ];

    for (const fn of candidates) {
      if (typeof fn === 'function') {
        try {
          fn();
        } catch (error) {
          console.warn('[cart-haisosm-slot] reinit failed', error);
        }
      }
    }

    dispatchReady();
  }

  let refreshScheduled = false;
  function scheduleRefresh() {
    if (refreshScheduled) return;
    refreshScheduled = true;
    requestAnimationFrame(() => {
      refreshScheduled = false;
      tryAppReinit();
    });
  }

  document.addEventListener('cart:update', scheduleRefresh);
  document.addEventListener('dialog:open', (event) => {
    if (event.target instanceof Element && event.target.closest('cart-drawer-component')) {
      scheduleRefresh();
    }
  });

  const slotObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        const slot = getSlot();
        if (slot && slot.childElementCount === 0) {
          scheduleRefresh();
        }
        break;
      }
    }
  });

  let slotObserved = false;

  function observeSlot() {
    const slot = getSlot();
    if (!slot || slotObserved) return;
    slotObserver.observe(slot, { childList: true, subtree: true });
    slotObserved = true;
  }

  function init() {
    observeSlot();
    scheduleRefresh();

    new MutationObserver(() => {
      if (!getSlot()) {
        slotObserved = false;
        return;
      }
      observeSlot();
      if (getSlot()?.childElementCount === 0) {
        scheduleRefresh();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:update', () => {
    requestAnimationFrame(() => {
      slotObserved = false;
      observeSlot();
      scheduleRefresh();
    });
  });
})();
